import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';

export enum SidePanelState {
  opportunityDetails = 'opportunity-details',
  opportunityCreate = 'opportunity-create',
  manualAutomation = 'manual-automation',
  snapshotView = 'snapshot-view',
  orderCreate = 'order-create',
  campaignCreate = 'campaign-create',
  contactListActions = 'contact-list-actions',
  empty = 'empty',
}

// Add more types as needed
export interface CampaignSidePanelDataInterface {
  accountGroupId: string;
}

export type SidePanelStateDataTypes = CampaignSidePanelDataInterface;

export interface SidePanelStateData<T> {
  state: SidePanelState;
  data: T;
}

@Injectable()
export class SidePanelStateService {
  private readonly sidePanelState$$ = new ReplaySubject<SidePanelStateData<any>>(1);
  readonly sidePanelState$: Observable<SidePanelStateData<any>> = this.sidePanelState$$.asObservable();

  switchState<T>(state: SidePanelState, data?: T): void {
    this.sidePanelState$$.next({ state: state, data: data });
  }
}
